import { ISender } from './ISender';
import { IMessage } from './IMessage';


export class MessagePackage
{
    public Sender?: ISender | "Anonymous";
    public Message!: IMessage;
}
